export default __webpack_public_path__ + "static/media/dearlila1.49c98e72.jpg";